import { Pipe, PipeTransform } from '@angular/core';
import { IFormField } from '@appgen-health-crm/api-interfaces';

// this pipe will call the function only once instead of calling it each time change detection happens
@Pipe({
  name: 'otherFields',
  pure: true
})
export class OtherFieldsPipe implements PipeTransform {
  transform(currField: IFormField, allFields: IFormField[]): IFormField[] {
    return allFields
      .filter(x => x.type === 'polar' && x.name !== currField.name)
      .map(x => ({ ...x }));
  }
}
